import React, { useContext, useEffect, useRef, useState } from 'react'
import { IoLocationSharp, IoSearchOutline } from "react-icons/io5";
import { getTmsVehicleCounts } from '_services';
import StorageService from 'utils/StorageServices/StorageServices';
import Loading from 'pages/Loading';
import { UserContext } from 'context';
import { GPSConfig } from "lib";
import { DashboardVehicleGpsTracker } from 'components';
import { Link } from 'react-router-dom';

const vehicleGpsTabs = [
    { id: 1, title: "Planned", count: 0 },
    { id: 2, title: "Not Planned", count: 0 },
]

const VehicleDashboard = () => {

    const { masterData } = useContext(UserContext);
    const [vehicleList, setVehicleList] = useState([]);
    const [vehicleLoading, setVehicleLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const [tmsCounts, setTmsCounts] = useState([]);
    const [planningCoutData, setPlanningCoutData] = useState([]);
    const [gpsStatusCountData, setGpsStatusCountData] = useState([]);

    const [tripActiveTab, setTripActiveTab] = useState(0);
    const [planningActiveTab, setPlanningActiveTab] = useState(1);
    const [gpsStatusActiveTab, setGPSStatusActiveTab] = useState(0);

    const [activeMarker, setActiveMarker] = useState(null);

    const hoverTimer = useRef(null);

    const [offset, setOffset] = useState(1);
    const [hasMoreData, setHasMoreData] = useState(true);

    const [keyward, setKeyward] = useState('')


    const containerRef = useRef(null);
    const joinedRoomsRef = useRef(new Set());



    const fatchTmsVehicleCounts = async () => {
        if (vehicleLoading || !hasMoreData) return;

        setVehicleLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                vehicle_status: tripActiveTab,
                limit: 20,
                offset: offset,
                search: keyward,
                gps_status: gpsStatusActiveTab
            };

            const res = await getTmsVehicleCounts(object);

            if (res?.responseCode === 200) {
                const vehicles = res?.data?.vehicles || [];
                const totalRecord = res?.data?.total_record || 0;

                if (vehicleList.length + vehicles.length >= totalRecord) {
                    setHasMoreData(false);
                }

                setOffset(prev => prev + 1);

                let newData = res?.data?.utilization?.map((el) => {
                    return {
                        id: el?.vehicle_status,
                        title: el?.label,
                        value: el?.value,
                        count: el?.value
                    }
                })
                setTmsCounts(newData);

                let gpsData = res?.data?.gps_status?.map((el, index) => {
                    return {
                        title: el?.label,
                        value: el?.gps_status,
                        count: el?.value
                    }
                })
                setGpsStatusCountData(gpsData);

                setVehicleList((prevList) => {
                    const prevStartPoints = {};
                    prevList?.forEach(vehicle => {
                        if (vehicle?.start_latitude && vehicle?.start_longitude) {
                            prevStartPoints[vehicle._id] = {
                                lat: vehicle.start_latitude,
                                lng: vehicle.start_longitude
                            };
                        }
                    });

                    const updatedVehicles = vehicles.map((vehicle) => {
                        const gps = vehicle?.gps_data;
                        if (!gps?.latitude || !gps?.longitude) return vehicle;

                        const lat = parseFloat(gps.latitude);
                        const lng = parseFloat(gps.longitude);
                        const existingStart = prevStartPoints[vehicle._id];

                        return {
                            ...vehicle,
                            start_latitude: existingStart?.lat ?? lat,
                            start_longitude: existingStart?.lng ?? lng,
                        };
                    });

                    return [...prevList, ...updatedVehicles];
                });
            }
        } catch (error) {
            console.error("Error fetching vehicles", error);
        } finally {
            setVehicleLoading(false);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            fatchTmsVehicleCounts();
        }
    };


    // const fatchTmsVehicleCounts = async () => {
    //     try {
    //         let object = {
    //             company_id: StorageService.getCompanyId(),
    //             vehicle_status: tripActiveTab,
    //             limit: 20,
    //              offset: offset,
    //             search: ""
    //         }
    //         const res = await getTmsVehicleCounts(object);
    //         if (res?.responseCode == 200) {
    //             let newData = res?.data?.utilization?.map((el) => {
    //                 return {
    //                     id: el?.vehicle_status,
    //                     title: el?.label,
    //                     value: el?.value,
    //                     count: el?.value
    //                 }
    //             })
    //             setTmsCounts(newData);
    //             // setVehicleList(res?.data?.vehicles);
    //             setVehicleList((prevList) => {
    //                 const prevStartPoints = {};

    //                 // Map previous start coordinates by vehicle _id
    //                 prevList?.forEach(vehicle => {
    //                     if (vehicle?.start_latitude && vehicle?.start_longitude) {
    //                         prevStartPoints[vehicle._id] = {
    //                             lat: vehicle.start_latitude,
    //                             lng: vehicle.start_longitude
    //                         };
    //                     }
    //                 });

    //                 const updatedVehicles = res?.data?.vehicles?.map((vehicle) => {
    //                     const gps = vehicle?.gps_data;

    //                     if (!gps?.latitude || !gps?.longitude) return vehicle;

    //                     const lat = parseFloat(gps.latitude);
    //                     const lng = parseFloat(gps.longitude);

    //                     const existingStart = prevStartPoints[vehicle._id];

    //                     return {
    //                         ...vehicle,
    //                         start_latitude: existingStart?.lat ?? lat,
    //                         start_longitude: existingStart?.lng ?? lng,
    //                     };
    //                 });

    //                 return updatedVehicles;
    //             });

    //         }
    //     } catch (error) {
    //         // throw error;
    //     }
    // }

    // useEffect(() => {
    //     fatchTmsVehicleCounts();
    // }, [tripActiveTab])

    useEffect(() => {
        const init = async () => {
            setInitialLoading(true);
            await fatchTmsVehicleCounts();
            setInitialLoading(false);
        };
        init();
    }, [tripActiveTab, gpsStatusActiveTab, keyward])

    const setInitial = () => {
        setOffset(1)
        setVehicleLoading(false);
        setHasMoreData(true)
        setVehicleList([])
    }

    const fetchUti = (item) => {
        setInitial()
        setTripActiveTab(item)
    }

    const fetchPlanning = (item) => {
        setInitial()
        setPlanningActiveTab(item)
    }

    const fetchGpsStatus = (item) => {
        setInitial()
        setGPSStatusActiveTab(item)
    }

    const searchVehicle = (e) => {
        const value = e.target.value
        setInitial()
        setKeyward(value)
    }

    // useEffect(() => {
    //     if (!socket?.connected || !vehicleList?.length) return;

    //     vehicleList.forEach(vehicle => {
    //         const room = `${vehicle?.gps_data?.companyId}_${vehicle.vehicle_no}`;

    //         // Emit only if not already joined
    //         if (!joinedRoomsRef.current.has(room)) {
    //             socket.emit("joinRoom", room);
    //             joinedRoomsRef.current.add(room);
    //         }
    //     });
    // }, [socket.connected, vehicleList]);

    // useEffect(() => {
    //     if (!socket.connected) {
    //         socket.connect();
    //     }

    //     socket.on("connect", () => {
    //         console.log("Socket connected:", socket.id);
    //     });

    //     socket.on("disconnect", () => {
    //         console.log("Socket disconnected");
    //     });

    //     socket.on("joinedRoom", (roomId) => {
    //         console.log("Successfully joined", roomId);
    //     });

    //     socket.on("fetchVehicleDetail", (payload) => {
    //         setVehicleList((prevList) => {
    //             const updatedList = prevList.map((vehicle) => {
    //                 if (vehicle.gps_data?.vehicleNumber === payload.vehicleNumber) {
    //                     return {
    //                         ...vehicle,
    //                         gps_data: {
    //                             ...vehicle.gps_data,
    //                             ...payload
    //                         }
    //                     };
    //                 }
    //                 return vehicle;
    //             });
    //             return updatedList;
    //         });
    //     });

    //     return () => {
    //         socket.off("connect");
    //         socket.off("disconnect");
    //         socket.off("joinedRoom");
    //         socket.off("fetchVehicleDetail");
    //     };
    // }, []);

    return (
        <div className='_vehiCle_dash_main'>

            <div className='__utilAd_gpsBx'>

                <div className='__util_sepBx'>
                    <p>Utilization</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="utilization" role="utilization">
                            {tmsCounts?.length > 0 ? tmsCounts?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.title + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (tripActiveTab === item?.id ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={tripActiveTab === item?.id}
                                        // onClick={(e) =>  setTripActiveTab(item.id)}
                                        onClick={(e) => fetchUti(item.id)}
                                    // disabled={loading}
                                    >
                                        <span className=''>{item?.title}</span>
                                        <span className=''>{item?.count} </span>

                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>

                <div className='__util_sepBx'>
                    <p>Planning</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="planning" role="tabPlanning">
                            {vehicleGpsTabs?.length > 0 ? vehicleGpsTabs?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.title + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (planningActiveTab === item?.id ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={planningActiveTab === item?.id}
                                        onClick={(e) => fetchPlanning(item.id)}
                                    // disabled={loading}
                                    >
                                        <span className=''>{item?.title}</span>
                                        <span className=''>{item?.count} </span>

                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>

                <div className='__util_sepBx'>
                    <p>GPS Status</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="gpsStatus" role="tabGPSStatus">
                            {gpsStatusCountData?.length > 0 ? gpsStatusCountData?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.title + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (gpsStatusActiveTab === item?.value ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={gpsStatusActiveTab === item?.value}
                                        onClick={(e) => fetchGpsStatus(item.value)}
                                    // disabled={loading}
                                    >
                                        <span className=''>{item?.title}</span>
                                        <span className=''>{item?.count} </span>

                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>
            </div>


            <div className='_vehiCle_dash_mapPart'>

                <div className='__vhl_leftPart'>
                    <div className="reactour__searchBar">
                        <div className="pos-rel w-100">
                            <input type="text" className="_vehCle_search" placeholder='Search Vehicle or Location'
                                onChange={(e) => searchVehicle(e)}
                            />
                            <span className="pos-abs _serIcon"><IoSearchOutline /></span>
                        </div>
                    </div>
                    <div className="pre-scrollable "
                        ref={containerRef}
                        onScroll={handleScroll}
                    // style={{ maxHeight: '500px', overflowY: 'auto' }}

                    >


                        {
                            initialLoading ?
                                <div colSpan="100%" className="loaderBg" style={{ textAlign: "start" }}>
                                    <Loading />
                                </div>
                                :
                                <React.Fragment>
                                    {(vehicleList?.length > 0 ? vehicleList?.map((el, ind) => {
                                        return (
                                            <React.Fragment key={ind}>
                                                <Link
                                                    to={`/dashboard?t=gps_timeline&vn=${el.vehicle_no}&tbn=1&cmid=${StorageService.getCompanyId()}`}
                                                    className={`_realTime_bx ${activeMarker?.id === el._id ? "active-vehicle" : ""}`}

                                                    onMouseEnter={() => {
                                                        hoverTimer.current = setTimeout(() => {
                                                            setActiveMarker({
                                                                id: el._id,
                                                                position: {
                                                                    lat: parseFloat(el?.gps_data?.latitude),
                                                                    lng: parseFloat(el?.gps_data?.longitude),
                                                                },
                                                                gps: el.gps_data,
                                                                vehicle: el,
                                                            });
                                                        }, 1000); // 2 seconds
                                                    }}
                                                    onMouseLeave={() => {
                                                        clearTimeout(hoverTimer.current);
                                                        setActiveMarker(null)
                                                    }}
                                                >
                                                    <div className='d-flex justify-content-between flex-wrap align-items-start' style={{ marginBottom: '12px' }}>
                                                        <div className='__realTime_bx__top'>
                                                            <div className='__kmphBx'>
                                                                <div className='__kmSpeed'><p>{el?.gps_data?.speed}</p></div>
                                                                <div className='__kmphInner'>Kmph</div>
                                                            </div>

                                                            <div className='__realTime_vhl'>
                                                                <h4>{el?.vehicle_no}</h4>
                                                                <p><span>Stopped since 5 Hours</span> | 178 KM Today</p>
                                                            </div>
                                                        </div>

                                                        <div className='__whlTag'><span>{el?.gps_data?.provider}</span></div>
                                                    </div>

                                                    <div>
                                                        <div className='__realTime_bx__bottom'>
                                                            <div className='d-flex gap-1'>
                                                                <span className='__locIcon'><IoLocationSharp /></span>
                                                                <div className='__realTime_bx__bottom__loc'>
                                                                    <h6>{el?.gps_data?.location}</h6>
                                                                    <p>Last updated on {el.gps_data?.dttime}</p>
                                                                </div>
                                                            </div>

                                                            {el?.current_trip != null ?
                                                                <div className='__realTime_bx__bottom__trip'>
                                                                    <span style={{ backgroundColor: '#FFAC05' }}></span>
                                                                    <p>{el?.current_trip?.trip_status ? masterData.trip_status[el?.current_trip?.trip_status] : '-'} &nbsp; #TRIP {el?.current_trip?.trip_number ? el?.current_trip?.trip_number : '-'}- {el?.current_trip?.route_name ? el?.current_trip?.route_name : '-'}</p>
                                                                </div> :
                                                                <div className='__realTime_bx__bottom__trip'>
                                                                    <span style={{ backgroundColor: '#3E9828' }}></span>
                                                                    <p>{el?.vehicle_status ? masterData.vehicle_status[el?.vehicle_status] : '-'} </p>
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className='__nxtTrip'>
                                                            <span style={{ opacity: '0.5' }}>Next Trip- </span> <span style={{ opacity: '0.8' }}>Not Planned</span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </React.Fragment>
                                        )
                                    }) : <span className='fonts_cts'> No data found </span>)}
                                    <React.Fragment>
                                        {vehicleLoading && (
                                            <div style={{ textAlign: "center", padding: "10px" }}>
                                                loading...
                                            </div>
                                        )
                                        }
                                    </React.Fragment>
                                </React.Fragment>
                        }
                    </div>
                </div>
                <div className='__vhl_rightPart'>
                    <div style={{ minHeight: '100%', width: '100%', position: 'relative' }}>
                        <div style={{ width: "100%", height: "100%", position: 'relative' }}>
                            <DashboardVehicleGpsTracker vehicleList={vehicleList} activeMarker={activeMarker} setActiveMarker={setActiveMarker} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default VehicleDashboard